import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    createTagDrawerContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 'calc(100% - 60px)'
    },
    createTagDrawerBody: {
        overflowX: 'hidden',
        height: '100%',
        padding: 0,
        justifyContent: 'center',
        marginTop: theme.spacing(2)
    },
    saveNewTagButton: {
        marginTop: theme.spacing(1)
    },
    tagsToastIcon: {
        '& path': {
            fill: theme.palette.common.white
        }
    }
}));
